import React, { useState } from "react";
import Delete from '../../assets/delete.png';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import '../../components/DialogBoxCustom.css'
import useApiPost from "../hooks/postData";

function AddLanguage({ openAddLanguage, handleCloseAdd, handleDelete }) {

    const {data,error,postData} = useApiPost()
    const [languageName,setLanguageName] = useState("")
    const [showDropdown, setShowDropdown] = useState(false);

    const addLanguage = () => {
        const response = postData("/addLanguageColumn",{language:languageName})
        handleCloseAdd()
    }
   

    
    return (
        <Dialog open={openAddLanguage} onClose={handleCloseAdd} fullWidth className="hashtag-dialog" >
            <DialogTitle className="flex justify-center text-base font-bold text-[#000000] font-poppins bg-[#FFFFFF] dark:bg-primary shadow-lg light:rounded-lg dark:text-darkText">Add Language</DialogTitle>
           
            <button onClick={handleCloseAdd} className="absolute text-2xl text-gray-600 dark:text-white top-2 right-4">
                 ×
            </button>
            <DialogContent className="flex flex-col light:mx-5 dark:bg-primary">
                {/* Language Name Input*/}
                <h2 className="text-base font-poppins text-[#000000] pt-4  font-semibold dark:text-darkText">Language Name</h2>
                <input type="text" placeholder="Enter Language Name"
                className="border border-opacity-gradient rounded-lg dark:bg-transparent dark:border-[#1F1F1F] placeholder:text-tableDarkLarge dark:text-darkText w-full py-3 my-1 px-4 placeholder:font-gilroy_regular placeholder:text-sm placeholder:text-[#000000] placeholder:opacity-50 bg-white focus:outline-none focus:ring-1 focus:ring-header"
                onChange={(e) => setLanguageName(e.target.value)} 
                value={languageName}/>
                
                {/* Submit button */}
                <div className="flex justify-center py-6">
                    <button className="px-20 py-3 font-medium text-white rounded-xl bg-button-gradient" onClick={addLanguage}>
                        Submit
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default AddLanguage;








